import constants from "../consts/constants";
import axios from "axios"

class Api {
    constructor ({ serverUrl }) {
        this._serverUrl = serverUrl
    }

    async SearchUserAdm(adminData, searchUser) {
        const res = await axios.post(`${this._serverUrl}/searchusadm`, {adminData: adminData, searchUser: searchUser})
        return {res: res.data, status: res.status}
    }
    async DeleteUserAdm(adminData, delUserData) {
        const res = await axios.post(`${this._serverUrl}/deleteuseradm`, {adminData: adminData, delUserData: delUserData})
        return {res: res.data, status: res.status}
    }

    async LoadAdmin(adminData) {
        const res = await axios.post(`${this._serverUrl}/loadadmin`, {adminData: adminData})
        return {res: res.data, status: res.status}
    }
    async ViewAdmins(adminData) {
        const res = await axios.post(`${this._serverUrl}/viewadmins`, {adminData: adminData})
        return {res: res.data, status: res.status}
    }
    async CreateAdmin(adminData, newAdminData) {
        const res = await axios.post(`${this._serverUrl}/createadmin`, {adminData: adminData, newAdminData: newAdminData})
        return {res: res.data, status: res.status}
    }
    async EditAdmin(adminData, edAdminData) {
        const res = await axios.post(`${this._serverUrl}/editadmin`, {adminData: adminData, edAdminData: edAdminData})
        return {res: res.data, status: res.status}
    }
    async DeleteAdmin(adminData, delAdminData) {
        const res = await axios.post(`${this._serverUrl}/deleteadmin`, {adminData: adminData, delAdminData: delAdminData})
        return {res: res.data, status: res.status}
    }

    async LoadEvents() {
        const res = await axios.get(`${this._serverUrl}/loadevents`)
        return {res: res.data, status: res.status}
    }

    async CreateEvent(adminData, eventData) {
        const res = await axios.post(`${this._serverUrl}/createevent`, {adminData: adminData, eventData: eventData})
        return {res: res.data, status: res.status}
    }
    async EditEvent(adminData, edEventData) {
        const res = await axios.post(`${this._serverUrl}/editevent`, {adminData: adminData, edEventData: edEventData})
        return {res: res.data, status: res.status}
    }
    async ChangeEventStatus(adminData, edEventData) {
        const res = await axios.post(`${this._serverUrl}/changeventstatus`, {adminData: adminData, edEventData: edEventData})
        return {res: res.data, status: res.status}
    }
    async DeleteMember(adminData, eventData, memberData) {
        const res = await axios.post(`${this._serverUrl}/deletemember`, {adminData: adminData, eventData: eventData, memberData: memberData})
        return {res: res.data, status: res.status}
    }
    async ScanQR(adminData, qrData) {
        const res = await axios.post(`${this._serverUrl}/scanqr`, {adminData: adminData, qrData: qrData})
        return {res: res.data, status: res.status}
    }
}

const API = new Api({
    serverUrl: constants.serverUrl
})

export default API